import { useState } from 'react'

import { ExportModal } from './ExportModal'
import { PopoverMenu } from './PopoverMenu'

const Exports = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const closeModal = () => setIsOpen(false)
  const openModal = () => setIsOpen(true)

  return (
    <>
      {isOpen && <ExportModal onClose={closeModal} />}
      <PopoverMenu onClickExport={openModal} />
    </>
  )
}

export default Exports
